import React from 'react';
import HeroSection from '../components/home/HeroSection';
import FeaturesSection from '../components/home/FeaturesSection';
import HowItWorksSection from '../components/home/HowItWorksSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import CTASection from '../components/home/CTASection';

// AI CTA section — inline since it's home-page-specific and small
const AICTASection: React.FC = () => {
  return (
    <section className="page" style={{ paddingTop: 80 }}>
      <div
        className="card"
        style={{
          padding: 48,
          background: 'linear-gradient(135deg, var(--brand-navy), var(--brand-ink))',
          color: '#fff',
          border: 'none',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'absolute',
            right: -40,
            top: -40,
            width: 280,
            height: 280,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(25,198,230,0.3), transparent 70%)',
          }}
        />
        <div style={{ maxWidth: 560, position: 'relative' }}>
          <span className="badge badge-cyan">NEW · AI Shipment</span>
          <h2
            style={{
              fontSize: 36,
              fontWeight: 600,
              letterSpacing: '-0.02em',
              marginTop: 16,
              color: '#fff',
            }}
          >
            Paste an invoice. Get a label.
          </h2>
          <p style={{ marginTop: 12, color: '#cfd1e4', fontSize: 16 }}>
            Our shipment assistant reads orders, invoices and emails — fills the form, picks the
            best carrier, schedules pickup. You confirm and pay.
          </p>
          <a
            href="/ai-shipment"
            className="btn btn-lg"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              marginTop: 24,
              background: 'var(--brand-cyan)',
              color: 'var(--brand-navy)',
              textDecoration: 'none',
            }}
          >
            Try AI shipment
          </a>
        </div>
      </div>
    </section>
  );
};

const HomePage: React.FC = () => (
  <div>
    <HeroSection />
    <FeaturesSection />
    <HowItWorksSection />
    <AICTASection />
    <TestimonialsSection />
    <CTASection />
  </div>
);

export default HomePage;
